export default __webpack_public_path__ + "media/images/bancontact-20848c1229c755077cfa8b1880dc6000.svg";